
	import { defineComponent } from "vue";
	import InlineLoadingIndicator from "@/components/InlineLoadingIndicator.vue";

	export default defineComponent({
		components: {
			InlineLoadingIndicator,
		},
	});
